<template>
    <v-form :name="searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <FormInputText fieldName="provider_name"
                                   label="Provider name"
                                   size="10"
                                   :isFocus="true"
                                   v-model:field="search.provider_name" />

                    <FormInputText fieldName="full_name"
                                   label="KRS name"
                                   size="12"
                                   v-model:field="search.full_name" />

                    <FormInputText fieldName="symbol"
                                   label="Symbol"
                                   size="2"
                                   v-model:field="search.symbol" />

                    <FormInputText fieldName="street"
                                   label="Street"
                                   size="3"
                                   v-model:field="search.street" />

                    <FormInputText fieldName="zip"
                                   label="Postal code"
                                   size="3"
                                   v-model:field="search.zip" />

                    <FormInputText fieldName="town"
                                   label="Town"
                                   size="3"
                                   v-model:field="search.town" />

                    <FormInputText fieldName="NIP"
                                   label="NIP"
                                   size="3"
                                   v-model:field="search.NIP" />

                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})

const autoSearch = ref(false)

let search = ref({})
prepareSearch(search, props)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
